module.exports = __webpack_public_path__ + "static/img/270_TO8_2374.77ec1a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/270_TO8_2374.jpg
// module id = YZGB
// module chunks = 0